import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import scriptLoader from 'react-async-script-loader';
import config from 'config';

import './contacts-map.scss';

class ContactsMap extends PureComponent {
  componentWillReceiveProps({ isScriptLoadSucceed }) {
    if (isScriptLoadSucceed) {
      const { ymaps } = window;
      const { positionView } = this.props.content;
      ymaps.ready(() => {
        const map = new ymaps.Map(this.mapNode, {
          center: [positionView.lat, positionView.lng],
          controls: [],
          zoom: 17
        }, {
          searchControlProvider: 'yandex#search'
        });
        const MyIconContentLayout = new ymaps.Placemark(map.getCenter(), {
          hintContent: 'Юнисервис Капитал'
        }, {
          iconLayout: 'default#image',
          iconImageHref: '/marker.png',
          iconImageSize: [61, 49],
          iconImageOffset: [5, -48]
        });
        map.geoObjects.add(MyIconContentLayout);
      });
    }
  }

  render() {
    return (
      <div className="contacts-map">
        <div
          className="contacts-map-element"
          ref={elem => { this.mapNode = elem; }}
        />
      </div>
    );
  }
}

ContactsMap.propTypes = {
  content: PropTypes.shape({
    label: PropTypes.string,
    position: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number
    })
  })
};

export default scriptLoader([
  `https://api-maps.yandex.ru/2.1/?apikey=${config.YANDEX_MAP_API_KEY}&lang=ru_RU`
])(ContactsMap);



// WEBPACK FOOTER //
// ./src/components/Contacts/ContactsMap.js